import React from "react";
import { motion } from "framer-motion";
import { Container, Row, Col } from "react-bootstrap";
import { Link } from "react-router-dom";
import { FaSnowflake, FaArrowRight, FaCamera } from "react-icons/fa"; // Icons

import Navr from "../Navbar/Navr";
import Footer from "../Components2/Footer";

// Images Import
import heroImg from "../Ecomphotos/kashmir.jpg";
import srinagarImg from "../Ecomphotos/srinagar.jpg";
import pahalgamImg from "../Ecomphotos/pahal.jpg";
import gulmargImg from "../Ecomphotos/gul.jpg";
import sonmargImg from "../Ecomphotos/sonamarg.jpg";

export default function Kashmir() {
  // Data Array for Clean Code
  const locations = [
    {
      id: 1,
      name: "Srinagar",
      img: srinagarImg,
      desc: "The City of Lakes & Gardens",
    },
    { id: 2, name: "Pahalgam", img: pahalgamImg, desc: "Valley of Shepherds" },
    { id: 3, name: "Gulmarg", img: gulmargImg, desc: "Heart of Winter Sports" },
    { id: 4, name: "Sonmarg", img: sonmargImg, desc: "Meadow of Gold" },
  ];

  return (
    <div className="kashmir-page">
      <Navr />

      {/* --- Section 1: Hero Banner (Cinematic Parallax) --- */}
      <div
        className="kashmir-hero d-flex align-items-center justify-content-center"
        style={{ backgroundImage: `url(${heroImg})` }}
      >
        <div className="hero-gradient"></div>
        <Container className="text-center position-relative z-2">
          <motion.div
            initial={{ opacity: 0, scale: 0.9 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ duration: 1 }}
          >
            <h5 className="text-warning text-uppercase ls-3 mb-3">
              Welcome to Paradise
            </h5>
            <h1 className="display-1 fw-bold text-white mb-4 title-shadow">
              Kashmir
            </h1>
            <p
              className="text-white lead mx-auto opacity-75"
              style={{ maxWidth: "700px" }}
            >
              Experience the magic of snow-capped peaks, serene lakes, and
              vibrant culture.
            </p>
          </motion.div>
        </Container>
      </div>

      {/* --- Section 2: Experience / About --- */}
      <section className="py-5 bg-white">
        <Container>
          <Row className="align-items-center my-4">
            <Col lg={6} className="mb-4 mb-lg-0">
              <div className="img-frame-tilted">
                <img
                  src={heroImg}
                  className="img-fluid shadow-lg rounded"
                  alt="Kashmir Beauty"
                />
              </div>
            </Col>
            <Col lg={6} className="ps-lg-5">
              <h6 className="text-info fw-bold text-uppercase">
                The Crown of India
              </h6>
              <h2 className="mb-4 fw-bold text-dark display-6">
                Heaven is Real, and it's here.
              </h2>

              <p className="text-muted text-justify lead-sm">
                Experience the breathtaking beauty of Kashmir, the “Paradise on
                Earth,” with our exclusive tour package. Explore the stunning
                landscapes of <strong>Srinagar</strong> with its iconic Dal
                Lake, Shikara rides, and vibrant Mughal gardens. Discover the
                snow-capped mountains of <strong>Gulmarg</strong>, a hub for
                skiing, and enjoy the serene meadows of{" "}
                <strong>Pahalgam</strong>.
              </p>
              <p className="text-muted text-justify lead-sm">
                Whether you seek adventure, relaxation, or a romantic getaway,
                Kashmir promises memories that last a lifetime. Book your
                Kashmir tour today and immerse yourself in nature’s ultimate
                splendor.
              </p>

              <Link
                to="/contact"
                className="btn btn-info text-white rounded-pill px-4 py-2 mt-3 fw-bold shadow-sm"
              >
                Customize Your Trip <FaArrowRight className="ms-2" />
              </Link>
            </Col>
          </Row>
        </Container>
      </section>

      {/* --- Section 3: Popular Destinations (Glass Cards) --- */}
      <section className="py-5 bg-light section-places">
        <Container>
          <div className="text-center mb-5">
            <FaSnowflake className="text-info fs-1 mb-2 spin-slow" />
            <h2 className="fw-bold display-6">Top Destinations</h2>
            <p className="text-muted">Explore the jewels of the valley</p>
          </div>

          <Row className="g-4">
            {locations.map((place) => (
              <Col md={6} lg={3} key={place.id}>
                <div className="place-card">
                  <div className="place-img-wrap">
                    <img src={place.img} alt={place.name} />
                    <div className="place-overlay">
                      <FaCamera className="text-white fs-2 mb-2" />
                      <span className="text-white fw-bold">View Gallery</span>
                    </div>
                  </div>
                  <div className="place-info text-center p-3">
                    <h4 className="fw-bold mb-1">{place.name}</h4>
                    <span className="text-info small fst-italic">
                      {place.desc}
                    </span>
                  </div>
                </div>
              </Col>
            ))}
          </Row>
        </Container>
      </section>

      {/* --- Section 4: Aesthetic CTA --- */}
      <section className="cta-kashmir py-5 text-center text-white">
        <div className="cta-content">
          <h2 className="fw-bold mb-3">Dreaming of Snow?</h2>
          <p className="lead mb-4 opacity-75">
            Let Jawali Holidays plan your perfect escape to the valley.
          </p>
          <Link
            to="/Contact"
            className="btn btn-light text-dark fw-bold px-5 py-3 rounded-0 hover-scale"
          >
            START PLANNING
          </Link>
        </div>
      </section>

      <Footer />
    </div>
  );
}
